import './Credit.css';

function Credit() {
  return (
    <main className="App" style={{ height: '100vh', overflow: 'hidden' }}>

    <div className="credit-container">
      <h1>Credits</h1>
      <p>We would like to acknowledge the following contributors and technologies that made this project possible.</p>
      
      <section className="credit-section">
        <h2>Contributors</h2>
        <ul>
          <li><a href="https://0x4227.xyz">0x4227</a></li>

        </ul>
      </section>
      
      
      
      <section className="credit-section">
        <h2>Special Thanks</h2>
        <p>We are grateful to our community and early adopters for their valuable feedback and support.</p>
        <p>For more information, visit our <a href="https://wireframes.design">official website</a>.</p>
      </section>
    </div>
    </main>
  );
}

export default Credit;
